// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SimplifiedFiltersModal-filterModalContainer-ypcY2 {
    max-width: 600px;
    width: 100%;
}

.SimplifiedFiltersModal-panelHeader-d2Mvn {
    padding: 20px 24px;
    border-bottom: 1px solid var(--primary-border);
    background: var(--background-primary);
}

.SimplifiedFiltersModal-panelHeader-d2Mvn .SimplifiedFiltersModal-close-_8UT1 {
    font-size: 28px;
    font-weight: 300;
    color: var(--primary-foreground);
    opacity: 0.6;
}

.SimplifiedFiltersModal-panelHeader-d2Mvn .SimplifiedFiltersModal-close-_8UT1:hover {
    opacity: 1;
}

.SimplifiedFiltersModal-modalBody-GCDNr {
    padding: 24px;
    background: var(--background-primary);
    max-height: 70vh;
    overflow-y: auto;
}

.SimplifiedFiltersModal-filterContainer-c4kfC {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 24px;
}

.SimplifiedFiltersModal-filterSection-NfS2X {
    padding: 16px 0;
    border-bottom: 1px solid var(--primary-border);
}

.SimplifiedFiltersModal-filterSection-NfS2X:last-child {
    border-bottom: none;
}

.SimplifiedFiltersModal-applyButtonContainer-OrGLS {
    margin-top: 24px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
        -ms-flex-pack: end;
            justify-content: flex-end;
    padding-top: 16px;
    border-top: 1px solid var(--primary-border);
}

@media screen and (max-width: 767px) {
    .SimplifiedFiltersModal-filterModalContainer-ypcY2 {
        max-width: 100%;
        margin: 0;
    }

    .SimplifiedFiltersModal-modalBody-GCDNr {
        max-height: calc(100vh - 120px);
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/SimplifiedFiltersModal/SimplifiedFiltersModal.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,8CAA8C;IAC9C,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,qBAAyB;QAAzB,kBAAyB;YAAzB,yBAAyB;IACzB,iBAAiB;IACjB,2CAA2C;AAC/C;;AAEA;IACI;QACI,eAAe;QACf,SAAS;IACb;;IAEA;QACI,+BAA+B;IACnC;AACJ","sourcesContent":[".filterModalContainer {\n    max-width: 600px;\n    width: 100%;\n}\n\n.panelHeader {\n    padding: 20px 24px;\n    border-bottom: 1px solid var(--primary-border);\n    background: var(--background-primary);\n}\n\n.panelHeader .close {\n    font-size: 28px;\n    font-weight: 300;\n    color: var(--primary-foreground);\n    opacity: 0.6;\n}\n\n.panelHeader .close:hover {\n    opacity: 1;\n}\n\n.modalBody {\n    padding: 24px;\n    background: var(--background-primary);\n    max-height: 70vh;\n    overflow-y: auto;\n}\n\n.filterContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.filterSection {\n    padding: 16px 0;\n    border-bottom: 1px solid var(--primary-border);\n}\n\n.filterSection:last-child {\n    border-bottom: none;\n}\n\n.applyButtonContainer {\n    margin-top: 24px;\n    display: flex;\n    justify-content: flex-end;\n    padding-top: 16px;\n    border-top: 1px solid var(--primary-border);\n}\n\n@media screen and (max-width: 767px) {\n    .filterModalContainer {\n        max-width: 100%;\n        margin: 0;\n    }\n\n    .modalBody {\n        max-height: calc(100vh - 120px);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterModalContainer": `SimplifiedFiltersModal-filterModalContainer-ypcY2`,
	"panelHeader": `SimplifiedFiltersModal-panelHeader-d2Mvn`,
	"close": `SimplifiedFiltersModal-close-_8UT1`,
	"modalBody": `SimplifiedFiltersModal-modalBody-GCDNr`,
	"filterContainer": `SimplifiedFiltersModal-filterContainer-c4kfC`,
	"filterSection": `SimplifiedFiltersModal-filterSection-NfS2X`,
	"applyButtonContainer": `SimplifiedFiltersModal-applyButtonContainer-OrGLS`
};
module.exports = ___CSS_LOADER_EXPORT___;
